










































import { State, Action, Getter } from 'vuex-class';
import { Component, Vue, Watch, Prop, Emit } from 'vue-property-decorator';
import { ProfileState, User } from '../store/profile/types';
import axios from 'axios';
import store from '../store';
const namespace: string = 'profile';

@Component
export default class Welcome extends Vue {
  @Action('authenticateUser', { namespace }) public authenticateUser: any;

  private title: string = 'Welcome';
  private text: string = 'Here you can produce a Triple Impact Canvas that illustrates your business model from three perspectives: the commercial, the brand and sustainability and climate. Click Start to start immediately!';
  private showError: boolean = false;
  private errorMessage: string = 'Error when logging in. Please check e-mail and password.';
  private formValid = true;

  private username: string = '';
  private password: string = '';

  private welcomeDialog: boolean = true;

  // form input rules
  private emailRules = [
    (v: any) => !!v || 'E-mail is required',
    (v: any) => /.+@.+\..+/.test(v) || 'E-mail must be valid',
  ];

  private passwordRules = [
    (v: any) => !!v || 'Password is required',
  ];

  // methods
  private async doLogin() {
    this.showError = false;

    const user = {email : this.username, password: this.password};

    await this.authenticateUser(user);

    const state: any = store.state;
    const userFromState = state.profile.user;

    if (userFromState !== undefined && userFromState.isAuthenticated) {
      this.welcomeDialog = false;
      this.$emit('login');
    } else {
      this.showError = true;
    }
  }
}
